// --------------------------------------------------------------------------
// bannerSlider.js
// --------------------------------------------------------------------------
// Slick slider for main banner
// --------------------------------------------------------------------------

RN.bannerSlider = function() {

  'use strict';

  function init() {
    var slider = byBehaviour('banner-slider');
    var sliderData = slider.data('slickSettings')

    if (slider.length > 0) {
        slider.slick(sliderData);
    }
  }

  return {
    init: init
  };

}();
